import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import {useUser} from "./context/UserContext";
import MainLayout from "./components/layout/main-layout/MainLayout";
import LoginForm from "./app/LoginForm";
import ChangePassword from "./app/ChangePassword";
import EditProfile from "./app/EditProfile";
import Register from "./app/Register";
import RegisterSuccess from "./app/RegisterSuccess";
import RegisterVerification from "./app/RegisterVerification";
import {HelpPage} from "./app/HelpPage";
import {Footer} from "antd/es/layout/layout";
import UserSettings from "./app/UserSettings";
import {useEffect} from "react";
import ApiService from "./services/ApiService";
import LandingPage from "./app/LandingPage";
import UserDashboard from "./app/UserDashboard";
import EULA from "./app/EULA";
import Privacy from "./app/Privacy";
import AdminDashboard from "./app/AdminDashboard";
import UserProfile from "./app/UserProfile";
import ResetPasswordSend from "./app/ResetPasswordSend";
import ResetPassword from "./app/ResetPassword";
import ResetPasswordSuccess from "./app/ResetPasswordSuccess";
import InfoContentPage from "./app/InfoContentPage";
import HelpContentPage from "./app/HelpContentPage";
import ProjectListPage from "./app/ProjectListPage";
import Run from "./app-components/run-project/Run";
import MessagePage from "./app/MessagePage";

function PrivateRoute({children, ...rest})
{
    const {
        isAuth,
        setSettings
    } = useUser();

    const getSettings  = async () => {
        const res = await ApiService.User.UserSettings()
        if(res.success) {
            setSettings({
                settings: JSON.parse(res.data.settings),
                defaultSettings: res.data.defaultSettings,
            })
        }
    }

    useEffect(() => {
        getSettings()
    }, [])

    return (
        <Route {...rest} render={() =>
        {
            return isAuth()
                ? children
                : <Redirect to={'/app/login'} />
        }}/>
    )
}


export default function AppRouter()
{
    const {user} = useUser();

    return (
        <Router>
            <Switch>
                <Route path={'/app/login'} component={LoginForm}/>
                <Route path={'/app/register/success'} component={RegisterSuccess}/>
                <Route path={'/app/register/verification'} component={RegisterVerification}/>
                <Route path={'/app/register'} component={Register}/>
                <Route exact path={'/app/reset-password/send'}  component={ResetPasswordSend}/>
                <Route exact path={'/app/reset-password/success'}  component={ResetPasswordSuccess}/>
                <Route exact path={'/app/reset-password'}  component={ResetPassword}/>
                <Route path={'/app/eula'} component={EULA}/>
                <Route path={'/app/privacy'} component={Privacy}/>
                <PrivateRoute>
                    <div style={{display: 'flex', flexDirection: 'column', alignContent: 'space-between', height: '100%'}}>
                        <MainLayout>
                            <Switch>
                                {(<Route exact path={'/app/load-project'}  component={ProjectListPage}/>)}
                                {(<Route exact path={'/app/run'}  component={Run}/>)}
                                {/*{(<Route exact path={'/app/comparison-check'}  component={ComparisonCheck}/>)}*/}
                                {(<Route exact path={'/app/results'}  component={MessagePage}/>)}
                                {(<Route exact path={'/app/help'}  component={HelpPage}/>)}
                                {(<Route exact path={'/app/user/dashboard'}  component={UserDashboard}/>)}
                                {(<Route exact path={'/app/user/profile'}  component={UserProfile}/>)}

                                {user?.data?.isAdmin && (<Route exact path={'/app/admin/dashboard'}  component={AdminDashboard}/>)}
                                {user?.data?.isAdmin && (<Route exact path={'/app/admin/info-content'}  component={InfoContentPage}/>)}
                                {user?.data?.isAdmin && (<Route exact path={'/app/admin/help-content'}  component={HelpContentPage}/>)}

                                {(<Route exact path={'/app/profile/change-password'}  component={ChangePassword}/>)}
                                {(<Route exact path={'/app/profile/settings'}  component={UserSettings}/>)}
                                {(<Route exact path={'/app/profile/edit'}  component={EditProfile}/>)}

                                {(<Route exact path={'/app'}  component={ProjectListPage}/>)}
                                {(<Route exact path={'/'}  component={ProjectListPage}/>)}
                            </Switch>
                        </MainLayout>
                    </div>
                </PrivateRoute>
            </Switch>
        </Router>
    )
}

